import Typography from 'components/Typography';
import { TCustomComponentProps } from '../Markdown.types';

export const CustomParagraph = ({ children }: TCustomComponentProps<HTMLParagraphElement>) => {
  return <Typography>{children}</Typography>;
};
